import React, { useState, useRef } from 'react'
import UserAvatar from '../shared/UserAvatar'
import { createCommunityComment } from 'utils/teachingTeamApi'
import { trackEvent } from 'utils/analytics'

export default function CommunityCommentInput({ postId, teamId, currentUser, canInteract = true, onRequestJoin, onCommentCreated, translations = {} }) {
  const [body, setBody] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const inputRef = useRef(null)

  if (!currentUser) {
    return (
      <div className="flex items-center gap-2 pt-2">
        <div
          className="flex-1 bg-gray-50 border border-gray-200 rounded-full px-4 py-1.5 cursor-pointer hover:border-gray-300 transition-colors"
          onClick={() => {
            window.location.href = `/users/sign_in?redirect_to=${encodeURIComponent(window.location.href)}`
          }}
        >
          <span className="text-sm text-gray-400">
            {translations.login_to_comment || '登入後即可留言'}
          </span>
        </div>
      </div>
    )
  }

  // Logged in but can't interact (not a paid student or team member)
  if (!canInteract) {
    return (
      <div className="flex items-center gap-2 pt-2">
        <UserAvatar
          src={currentUser.avatar_url}
          name={currentUser.name}
          size="xs"
          fallbackColor="#3366FF"
        />
        <div
          className="flex-1 bg-gray-50 border border-gray-200 rounded-full px-4 py-1.5 cursor-pointer hover:border-gray-300 transition-colors"
          onClick={() => onRequestJoin ? onRequestJoin() : alert(translations.paid_students_only || '成為學員後就能留言囉！')}
        >
          <span className="text-sm text-gray-400">
            {translations.add_comment || '留言...'}
          </span>
        </div>
      </div>
    )
  }

  const handleKeyDown = async (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      await handleSubmit()
    }
  }

  const handleSubmit = async () => {
    const trimmed = body.trim()
    if (!trimmed || submitting) return

    setSubmitting(true)
    try {
      const data = await createCommunityComment(teamId, postId, trimmed)
      setBody('')
      onCommentCreated && onCommentCreated(data)
    } catch (err) {
      console.error('Failed to post comment:', err)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="flex items-center gap-2 pt-2">
      <UserAvatar
        src={currentUser.avatar_url}
        name={currentUser.name}
        size="xs"
        fallbackColor="#3366FF"
      />
      <div className="flex-1 flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-full px-4 py-1.5 focus-within:border-gray-400 transition-colors">
        <input
          ref={inputRef}
          type="text"
          value={body}
          onChange={(e) => setBody(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={translations.add_comment || 'Add a comment...'}
          className="flex-1 bg-transparent text-sm text-gray-800 placeholder-gray-400 outline-none"
          disabled={submitting}
        />
        {body.trim() && (
          <button
            onClick={handleSubmit}
            disabled={submitting}
            className="text-xs font-semibold text-blue-600 hover:text-blue-700 disabled:opacity-50 transition-colors"
          >
            {translations.post || 'Post'}
          </button>
        )}
      </div>
    </div>
  )
}
